<template>

    <div>

        <h6 class="mb-3 ml-3 text-sm-left">PERFIL DE USUARIO</h6>
        <div class="col-sm-12 mb-4">
            <b-overlay :show="show" rounded="sm">
                <b-card class="card mb-3 pt-3">
                    <div class="card-body">
                        <b-form method="post" @submit.prevent="updateProfile">
                            <div class="row mb-2 d-flex">
                                <div class="col-lg-12">
                                    <b-form-group>
                                        <label class="subtitle ml-2">Nombre <span class="text-danger font-weight-bolder">*</span></label>
                                        <b-form-input size="sm" v-model="user.Nombre" required>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row mb-2 d-flex">
                                <div class="col-lg-12">
                                    <b-form-group>
                                        <label class="subtitle ml-2">Apellidos <span class="text-danger font-weight-bolder">*</span></label>
                                        <b-form-input v-model="user.Apellidos" required>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row mb-2 d-flex">
                                <div class="col-lg-3">
                                    <b-form-group>
                                        <label class="subtitle ml-2">Cédula/Pasaporte <span class="text-danger font-weight-bolder">*</span></label>
                                        <b-form-input v-model="user.Cedula" required>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-9">
                                    <b-form-group>
                                        <label class="subtitle ml-2">Correo <span class="text-danger font-weight-bolder">*</span></label>
                                        <!--<b-icon v-b-popover.hover.rightbottom="'Credencial para acceder a la plataforma'" class="ci-hint text-danger font-weight-bolder" icon="question-circle"></b-icon>-->
                                        <b-form-input v-model="user.Email" required>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row mb-2 d-flex">
                                <div class="col-lg-4">
                                    <b-form-group>
                                        <label class="subtitle ml-2">País <span class="text-danger font-weight-bolder">*</span></label>
                                        <b-form-input v-model="user.Pais" required>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-4">
                                    <b-form-group>
                                        <label class="subtitle ml-2">Teléfono <span class="text-danger font-weight-bolder">*</span></label>
                                        <b-form-input v-model="user.Telefono" required>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-4">
                                    <b-form-group>
                                        <label class="subtitle ml-2">Fecha nacimiento <span class="text-danger font-weight-bolder">*</span></label>
                                        <b-form-datepicker class="subtitle ml-2" v-model="user.FechaDeNacimiento" placeholder="Fecha" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"></b-form-datepicker>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row mb-2 d-flex">
                                <div class="col-lg-6">
                                    <b-form-group>
                                        <label class="subtitle ml-2">Título profesional <span class="text-danger font-weight-bolder">*</span></label>
                                        <b-form-input v-model="user.TituloProfesional" required></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-6">
                                    <b-form-group>
                                        <label class="subtitle ml-2">Sector <span class="text-danger font-weight-bolder">*</span></label>
                                        <b-form-input v-model="user.Sector" required>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <cid-button type="submit" variant="primary">Actualizar Perfil</cid-button>
                        </b-form>
                    </div>
                </b-card>
                <b-card class="card mb-3 pt-3">
                    <div class="card-body">
                        <h6 class="mb-3 ml-3 text-sm-left">CREAR EMPRESA</h6>
                        <b-form @submit.prevent="crearEmpresa">
                            <div class="row mb-2 d-flex align-items-center">
                                <div class="col-lg-8">
                                    <b-form-group>
                                        <label class="subtitle ml-2">Nombre de la empresa <span class="text-danger font-weight-bolder">*</span></label>
                                        <b-form-input v-model="nombreEmpresa" required></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-4 mt-4">
                                    <b-form-group class="text-center">
                                        <cid-button type="submit" variant="success">Crear Empresa</cid-button>
                                    </b-form-group>
                                </div>
                            </div>
                        </b-form>
                    </div>
                </b-card>

                <!--
                <b-card class="card mb-3 pt-3">
                    <div class="card-body">
                        <b-form>
                            <div class="row mb-4">
                                <div class="col-lg-5">
                                    <b-form-group>
                                        <label class="subtitle ml-2">Invitar usuario</label>
                                        <b-form-input v-model="email" type="email" placeholder="Escribe el email del usuario">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-5">
                                    <b-form-group>
                                        <label class="subtitle ml-2">Nombre de Usuario</label>
                                        <b-form-input value="Nombre del usuario" class="inputLarge">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-2">
                                    <b-form-group>
                                        <cid-button class="button btn float-right mb-3 custom_color btn-primary btnInvitar btn-sm ml-4" @click="send">
                                            Enviar
                                            invitación
                                        </cid-button>
                                    </b-form-group>
                                </div>
                            </div>
                        </b-form>
                        <div class="row">
                            <div class="col-lg-12">
                                <b-table class="table" :fields="fields" :items="items">
                                    <template #cell(index)="data">
                                        {{ data.Nombre }}
                                    </template>
                                    <template #cell(index)="data">
                                        {{ data.Apellido }}
                                    </template>
                                    <template #cell(index)="data">
                                        {{ data.fields.Email }}
                                    </template>
                                    <template #cell(index)="data">
                                        {{ data.Telefono }}
                                    </template>
                                    <template #cell(index)="data">
                                        {{ data.Fecha }}
                                    </template>
                                    <template #cell(index)="data">
                                        {{ data.btnEditar }}
                                    </template>


                                </b-table>
                            </div>
                        </div>


                    </div>

                </b-card>
                       </ValidationObserver> -->
            </b-overlay>
        </div>

    </div>

</template>
<script>
    import axios from 'axios';
    import { extend } from 'vee-validate';
    import { required, email, min, regex } from 'vee-validate/dist/rules';

    extend('required', required);
    extend('email', email);
    extend('min', min);
    extend('regex', regex);

    extend('required', {
        message: 'Este campo es requerido',
    });

    extend('email', {
        message: 'Correo no válido',
    });

    export default {
        name: 'profile',
        data() {
            return {
                show: false,
                user: {},
                nombreEmpresa: '',
                items: [
                    {
                        Nombre: 'Nombre',
                        Apellido: 'Apellido',
                        Email: 'email@email.com',
                        Telefono: 'Teléfono',
                        Fecha: 'Fecha de invitación',
                        Editar: '',
                    },
                ],
            };
        },
        async mounted() {
            await this.retrieveProfileData();
        },
        methods: {
            async retrieveProfileData() {
                this.show = true;

                try {
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
                    const response = await axios.get('/api/Account/GetProfileData/');
                    if (response.data.IsSuccessFul) {
                        const userProfile = response.data.Result;
                        this.user = {
                            Nombre: userProfile.Name,
                            Apellidos: userProfile.Surname,
                            Email: userProfile.Email,
                            Cedula: userProfile.Dni,
                            Telefono: userProfile.PhoneNumber,
                            Sector: userProfile.Sector,
                            TituloProfesional: userProfile.Title,
                            FechaDeNacimiento: userProfile.Birthday,
                            Pais: userProfile.Country,
                        };
                    }
                } catch (error) {
                    console.error(error);
                }
                this.show = false;
            },
            updateProfile() {
                this.show = true;

                try {
                    const formData = new FormData();
                    formData.append('Name', this.user.Nombre);
                    formData.append('Dni', this.user.Cedula);
                    formData.append('Surname', this.user.Apellidos);
                    formData.append('Email', this.user.Email);
                    formData.append('PhoneNumber', this.user.Telefono);
                    formData.append('Title', this.user.TituloProfesional);
                    formData.append('Sector', this.user.Sector);
                    formData.append('Country', this.user.Pais);
                    formData.append('Birthday', this.user.FechaDeNacimiento);

                    axios.post('/api/Account/UpdateProfileData', formData)
                        .then(async (response) => {
                            this.show = false;
                            if (response.data != null) {
                                console.log(response.data);
                            }
                        });
                } catch (error) {
                    console.error(error);
                }
                this.loading = false;
            },
            crearEmpresa() {
                const empresaData = {
                    companyname: this.nombreEmpresa,
                };

                axios.post('/api/Invitation/CreateCompany/', empresaData)
                    .then(response => {
                        if (response.data.success) {
                            if (response.data.message === "Empresa Actualizada") {
                                this.mostrarNotificacion('Se ha agregado a la empresa', 'info');
                            } else if (response.data.message === "Empresa Creada") {
                                this.mostrarNotificacion('Su empresa ha sido creada', 'success');
                            } else {
                                this.mostrarNotificacion('Operación exitosa', 'success');
                            }
                        } else {
                            this.mostrarNotificacion('Error en la operación', 'danger');
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            },
            mostrarNotificacion(mensaje, variant) {
                this.$root.$bvToast.toast(mensaje, {
                    title: 'Notificación',
                    variant: variant,
                    solid: true,
                });
            },
        },
    };
</script>

<style>
    .card {
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        padding: 1rem 0rem 1rem 0rem;
    }

    .subtitle {
        color: grey;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.3;
    }

    .button.btn.btnInvitar {
        margin-top: 2rem;
    }
</style>
